import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pte_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const env = localStorage.getItem("pte_env") || "test";
  config.headers["X-Env"] = env;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("pte_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export default api;
